import script from "./NavigationOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationOverlay.vue?vue&type=script&setup=true&lang=js"

import "./NavigationOverlay.vue?vue&type=style&index=0&id=660f745f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660f745f"]])

export default __exports__